<script setup>
import PortalFooter from '@/components/portal/PortalFooter.vue'
import PortalLogo from '@/components/portal/PortalLogo.vue'
import Heading from '@/components/shared/page/Heading.vue'

//Emits and props
defineProps({
  heading: {
    type: String,
    default: '',
  },
  subHeading: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div :class="$style.wrapper">
    <main
      ref="main"
      :class="$style.main"
    >
      <div :class="$style.card">
        <div :class="$style.container">
          <div :class="$style.logoWrap">
            <PortalLogo />
          </div>
          <div :class="$style.content">
            <Heading :text="heading" />
            <small
              v-if="subHeading"
              text-muted
              text-centered
              :class="$style.subHeading"
            >
              {{ subHeading }}
            </small>
            <slot />
          </div>
        </div>
      </div>
      <PortalFooter />
    </main>
  </div>
</template>

<style module lang="scss">
.wrapper {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--bg-portal-wrapper);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 1.5rem 1.25rem;
  box-sizing: border-box;
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  max-width: 100%;
}
.card {
  width: 100%;
  max-width: 496px;
  flex-shrink: 0;
  background: var(--bg-portal-card);
  border: 1px solid var(--color-borders-light);
  border-radius: 12px;
  box-shadow: var(--box-shadow);
  padding: 2.75rem 1rem 4rem;
  box-sizing: border-box;
  @media (min-width: 640px) {
    padding: 2.75rem 2.75rem 4rem;
  }
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.subHeading {
  line-height: var(--line-height-text);
}
</style>
